export default __webpack_public_path__ + "static/media/set.afbb998e.svg";